module.exports = require('./helpers/bundle-url').getBundleURL('6e9Bk') + "logo-dark.ba5147f0.svg";